import { RotateCw, Eraser, Undo2, Trash2 } from "lucide-react";
import { ShapeThumb } from "@/components/game/Board";
import { SHAPE_KEYS, SHAPE_LABELS } from "@/game/shapes";

export const chipCls = (active, extra = "") =>
  `inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs md:text-sm font-semibold transition-colors duration-200 ${
    active ? "bg-[#2E5A3B] text-white" : "bg-white text-[#132A1D] border border-black/10 hover:bg-[#2E5A3B]/10"} ${extra}`;

export const Chip = ({ testid, onClick, active, children, extra }) => (
  <button data-testid={testid} onClick={onClick} className={chipCls(active, extra)}>{children}</button>
);

export const Palette = ({ shape, rot, color, erase, allowed, onShape, onRotate, onColor, onErase, onUndo, onClear, g }) => (
  <div className="bg-white rounded-2xl p-4 border border-black/5">
    <div className="flex flex-wrap gap-2 mb-4">
      <Chip testid="game-rotate" onClick={onRotate}><RotateCw size={14} /> {g.rotate}</Chip>
      <button data-testid="game-color" onClick={onColor}
        className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs md:text-sm font-semibold bg-white border border-black/10 hover:bg-black/5 transition-colors duration-200">
        <span className="w-4 h-4 rounded-full" style={{ background: color === "rosa" ? "#F2AEC4" : "#C6AE4E" }} /> {g.color}
      </button>
      <Chip testid="game-erase" onClick={onErase} active={erase}><Eraser size={14} /> {g.erase}</Chip>
      <Chip testid="game-undo" onClick={onUndo}><Undo2 size={14} /> {g.undo}</Chip>
      <Chip testid="game-clear" onClick={onClear}><Trash2 size={14} /> {g.clear}</Chip>
    </div>
    <div className="flex flex-wrap items-end gap-2" data-testid="game-palette">
      {SHAPE_KEYS.map((k) => {
        const off = allowed && !allowed.includes(k);
        return (
          <button key={k} data-testid={`shape-${k}`} onClick={() => !off && onShape(k)} title={SHAPE_LABELS[k]} disabled={off}
            className={`rounded-xl px-2 pt-2 pb-1 flex flex-col items-center gap-1 transition-colors duration-200 ${
              off ? "opacity-25 cursor-not-allowed bg-[#E9F4FA]" : shape === k && !erase ? "bg-[#BCE3F2] ring-2 ring-[#2E5A3B]" : "bg-[#E9F4FA] hover:bg-[#BCE3F2]"}`}>
            <ShapeThumb shape={k} rot={shape === k ? rot : 0} color={color} />
            <span className="text-[10px] text-[#5C5C5C] leading-none">{SHAPE_LABELS[k]}</span>
          </button>
        );
      })}
    </div>
  </div>
);
